<div *ngIf="userFullName && impersonatingUserFullName" class="impersonation-status">
    <span class="icon">
        <icon class="icon lg aa-icon-view-as-icon"></icon>
    </span>
    <span [innerHtml]="impersonationStatus"></span>
    <span class="separator">|</span>
    <a href="#" (click)="logOut()" translate="dismissViewAs"></a>
</div>